import { ref,reactive, computed, onMounted, watch, provide } from "vue";
import { getActiveDetail } from "~/api";
import { useRoute, useState } from "#app";
 
import { get } from "lodash-es";
import { makeAllArcListMap } from "~/utils/asyncData";
import { useMainStore } from "~/composables/store";
export default function pageEditorUse(
  { activeDetailData, currentPageIndex },
  { isPage, isMobile }
) {
  const store = useMainStore();
  const route = useRoute();
  const { locale } = useI18n();

  const edit = ref(
    (route.path && route.path.indexOf("/preview") >= 0) || false
  );
  const isEnterCtrl = ref(false);
  const langJsonState= reactive({
    langJsonConfigMap:{}
  })

  

  // provide('getActiveDetail_allArcListMap', () => {
  //   return {
  //     langJson: activeDetailData.allArcListMap || {},
  //   };
  // });

  if (isPage) {
    // 设置页面标题
    const siteInfo = store.getSiteInfo();
    if (siteInfo?.pc_SITE_NAME) {
      useHead({
        title: siteInfo.pc_SITE_NAME,
      });
    }
    if (isMobile) {
      useHead({
        meta: [
          { charset: "utf-8" },
          {
            hid: "viewport",
            name: "viewport",
            content: "width=device-width, user-scalable=yes,viewport-fit=cover",
          },
        ],
      });

      if (siteInfo?.mobile_SITE_NAME) {
        useHead({
          title: siteInfo.mobile_SITE_NAME,
          meta: [
            {
              hid: "description",
              name: "description",
              content:
                siteInfo.pc_SITE_NAME ||
                siteInfo?.mobile_SITE_NAME ||
                "企业官网",
            },
            {
              hid: "keywords",
              name: "keywords",
              content:
                siteInfo.pc_SITE_NAME ||
                siteInfo?.mobile_SITE_NAME ||
                "企业官网",
            }, // 搜索引擎能够识别抓取的关键字
          ],
        });
      }
    }
  }

  // 监听键盘事件
  const onkeydownFunc = (e) => {
    let e1 = e || event || window.event || arguments.callee.caller.arguments[0];
    if (e1.keyCode == 17) {
      console.log("lock");
      isEnterCtrl.value = true;
    }
  };

  const onkeyupFunc = (e) => {
    let e1 = e || event || window.event || arguments.callee.caller.arguments[0];
    if (e1.keyCode == 17) {
      console.log("unlock");
      isEnterCtrl.value = false;
    }
  };

  // 右键菜单处理
  const onContextmenu = (event) => {
    if (!process.client) {
      return;
    }
    if (!edit.value) return;
    event.preventDefault();

    if (route.path.indexOf("site") >= 0) return;

    let findLevelIdxs = "";
    let findItem = null;

    if (window.$(event.target).attr("data-target-level-keys")) {
      findItem = window.$(event.target);
      findLevelIdxs = window.$(event.target).attr("data-target-level-keys");
    } else if (
      window.$(event.target).parents("[data-target-level-keys]").size()
    ) {
      findItem = window
        .$(event.target)
        .parents("[data-target-level-keys]")
        .eq(0);
      findLevelIdxs = findItem.attr("data-target-level-keys");
    }
    if (!findLevelIdxs) return true;
    selectElement(findLevelIdxs.split("x"));
    if (isEnterCtrl.value) return;

    const componentNameMap = {
      Col: "栅格列",
      Row: "栅格行",
      Banner: "轮播图",
      TextItem: "文字",
      HtmlItem: "富文本",
      ImageItem: "图片",
      CommonComponentsItem: "公用模板组件",
      TabsItem: "tabs分类",
    };
    const componentName = findItem.attr("data-component-name");

    // 示例代码，假设使用vue-contextmenu.js
    // 需要根据具体实现调整
    if (typeof contextmenu != "undefined") {
      contextmenu({
        items: [
          {
            label: `${
              componentNameMap[componentName] || componentName
            }(${findLevelIdxs})`,
            divided: true,
            disabled: true,
            icon: "el-icon-menu",
          },
          {
            label: "上移",
            disabled: findItem.dataset.canMoveUp === "false",
            onClick: () => moveElementUp(findLevelIdxs.split("x")),
          },
          {
            label: "下移",
            disabled: findItem.dataset.canMoveDown === "false",
            onClick: () => moveElementDown(findLevelIdxs.split("x")),
          },
          {
            label: "复制",
            onClick: () => copyElement(findLevelIdxs.split("x")),
          },
          {
            label: "删除",
            onClick: () => removeElement(findLevelIdxs.split("x")),
          },
        ],
        event,
        customClass: "custom-class",
        zIndex: 3,
        minWidth: 230,
      });
    }

    return false;
  };

  // 刷新页面
  const eventToSetRenderData = (event) => {
    if (typeof event.data !== "string") return;

    const setData = event.data.split("-*-*-");
    if (setData[0] === "setPagesData") {
      try {
        let setPagesData = JSON.parse(setData[1]);
        setPagesData = setPagesData || [];
        activeDetailData.value.currentPageConfig =
          setPagesData[currentPageIndex.value];
        activeDetailData.value.pages = setPagesData || [];
      } catch (e) {
        console.error(e);
      }
    } else if (event.data.indexOf("setPagesSelectIdxData-") == 0) {
      const setIdx = event.data.split("-")[1].split("x");
      currentElementIndex.value = setIdx;
    } else if (event.data.indexOf("setPagesIdxData-") == 0) {
      const setIdx = event.data.split("-")[1];
      currentPageIndex.value = setIdx;
    } else if (event.data.indexOf("getLangJsonMap") == 0) {
      console.log(
        "this.langJsonMap",
        langJsonState.langJsonConfigMap
      );
      if (typeof top != "undefined")
        top.postMessage(
          "langJsonMap-*_*_*-" +
            JSON.stringify(langJsonState.langJsonConfigMap),
          "*"
        );
      if (typeof parent != "undefined"&& top != parent )
        parent.postMessage(
          "langJsonMap-*_*_*-" +
            JSON.stringify(langJsonState.langJsonConfigMap),
          "*"
        );
    }
  };

  // 元素选择
  const selectElement = (idx) => {
    currentElementIndex.value = idx;
    top.postMessage("selectPcElement-" + idx.join("x"), "*");
    if (typeof parent != "undefined" && parent != top)
      parent.postMessage("selectPcElement-" + idx.join("x"), "*");
  };

  // 删除元素
  const removeElement = (idx) => {
    top.postMessage("removePcElement-" + idx.join("x"), "*");
    if (typeof parent != "undefined" && parent != top)
      parent.postMessage("removePcElement-" + idx.join("x"), "*");
  };

  // 复制元素
  const copyElement = (idx) => {
    top.postMessage("copyPcElement-" + idx.join("x"), "*");
    if (typeof parent != "undefined" && parent != top)
      parent.postMessage("copyPcElement-" + idx.join("x"), "*");
  };

  // 元素上移
  const moveElementUp = (idx) => {
    top.postMessage("movePcElementUp-" + idx.join("x"), "*");
    if (typeof parent != "undefined" && parent != top)
      parent.postMessage("movePcElementUp-" + idx.join("x"), "*");
  };

  // 元素下移
  const moveElementDown = (idx) => {
    top.postMessage("movePcElementDown-" + idx.join("x"), "*");
    if (typeof parent != "undefined" && parent != top)
      parent.postMessage("movePcElementDown-" + idx.join("x"), "*");
  };

  onMounted(() => {
    if (process.client && edit.value) {
      window.addEventListener("message", eventToSetRenderData, false);
      document.addEventListener("keydown", onkeydownFunc);
      document.addEventListener("keyup", onkeyupFunc);
    }
  });

  onBeforeUnmount(() => {
    if (process.client && edit.value) {
      window.removeEventListener("message", eventToSetRenderData, false);
      document.removeEventListener("keydown", onkeydownFunc);
      document.removeEventListener("keyup", onkeyupFunc);
    }
  });
 
  setPageHeaderStyleConfig(activeDetailData.value || {});

  const currentElementIndex = ref([0]);
  // 获取页面元素索引
  const currentElementIndexStr = computed(() => {
    return currentElementIndex.value.join("x");
  });

  function getConfigJsonHook() {
    const currentActiveDetailData = activeDetailData.value || {};
    const currentPageConfig = currentActiveDetailData.currentPageConfig || {};
    const currentRoute = route || {};
    const storeState = store?.$state || {};
    const isPreview = !!(currentRoute.path && currentRoute.path.indexOf("/preview") >= 0);
    const localeCode = locale?.value || "zh-CN";
    const localeAliasMap = {
      "zh-CN": "hans",
      "zh-Hans": "hans",
      zh: "hans",
      "zh-TW": "hant",
      "zh-Hant": "hant",
      tw: "hant",
      "vi_VN": "vi",
      vi: "vi",
      "ja_JP": "ja",
      ja: "ja",
      en: "en",
    };
    const localeAlias = localeAliasMap[localeCode] || localeCode;
    
    return {
      isPreview,
      langJson: currentPageConfig.langJson || {},
      bindData: {
        common: {
          isH5: !!isMobile,
          isMobile: !!isMobile,
          isPreview,
          appHidden: false,
          locale: localeCode,
          nowLocale: localeAlias,
          routePath: currentRoute.path || "",
          routeFullPath: currentRoute.fullPath || "",
          routeQuery: currentRoute.query || {},
          routeParams: currentRoute.params || {},
        },
        locale: localeCode,
        nowLocale: localeAlias,
        route: {
          path: currentRoute.path || "",
          fullPath: currentRoute.fullPath || "",
          query: currentRoute.query || {},
          params: currentRoute.params || {},
        },
        siteInfo: store.getSiteInfo() || {},
        userInfo: storeState.userInfo || {},
        mallUserInfo: storeState.mallUserInfo || {},
        currentPageConfig,
        ...(currentActiveDetailData.bindData || {}),
        ...(currentPageConfig.bindData || {}),
      },
    };
  }
  function setLangJsonConfigMapHook(key,value) {
   
    if (!langJsonState.langJsonConfigMap) langJsonState.langJsonConfigMap = { };
    langJsonState.langJsonConfigMap[key] = value||true;
    return {
      langJson: langJsonState.langJsonConfigMap || {},
    };
  }
  return {
    langJsonState,
    setLangJsonConfigMapHook,
    getConfigJsonHook,
    currentElementIndex,
    currentElementIndexStr,
    edit,
    onContextmenu,
  };
}
export function setPageHeaderStyleConfig(activeDetailData){
  if (activeDetailData.currentPageConfig) {
    if (get(activeDetailData, "currentPageConfig.info.cssText", "")) {
      useHead({
        style: [
          {
            body: true,
            innerHTML: get(
              activeDetailData,
              "currentPageConfig.info.cssText",
              ""
            ),
          },
        ],
      });
    }
    if (
      process.client &&
      get(activeDetailData, "currentPageConfig.info.javascriptText", "")
    ) {
      useHead({
        script: [
          {
            type: "text/javascript",

            body: true,
            innerHTML: get(
              activeDetailData,
              "currentPageConfig.info.javascriptText",
              ""
            ),
          },
        ],
      });
    }
  }
}

export function getActiveDetailDataAsync(
  { $fetch, headers, id, url },
  { currentPageIndex }
) {
  const route = useRoute();
  return new Promise(async (resolve, reject) => {
    let resAll = {};



    try {
      resAll = await getActiveDetail(
        {
          id: route.query.id ||  id ,
          url: route.query.url || url ,
          pageNo: 1,
          pageSize: 1,
        },
        $fetch,
        headers
      );
    } catch (e) {
      console.error(e);
    }
  
    
    const res = resAll.data;
    let allArcListMap = {};
    let pages = [];
    const resMakeData = await makeAllArcListMap(
      $fetch,
      headers,
      res,
      allArcListMap,
      pages
    );

    const currentPageConfig =
      (resMakeData.pages && resMakeData.pages[currentPageIndex.value]) || null;

    resolve({
     
      currentPageConfig,
      pages: resMakeData.pages,
      allArcListMap: resMakeData.allArcListMap,
    });
  });
}
